import Body from './body';
import getErrors from './validation';

export default {
  body: Body,
  settings: null,
  getErrors
};
